import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "card__wrapper",
  ref: "hero"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card__img" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  ref: "socialsWrapper",
  class: "card__socials"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Share", -1)
const _hoisted_7 = { class: "card__socials-items" }
const _hoisted_8 = {
  ref: "controlsWrapper",
  class: "card__controls _mobile"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Create a New Tarot Spread", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_social_icon = _resolveComponent("social-icon")!
  const _component_touch_ripple = _resolveComponent("touch-ripple")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", { '_cover-header': _ctx.isCoverHeader }]),
    style: _normalizeStyle({ paddingTop: _ctx.paddingTop })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.card)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", {
              ref: "title",
              class: "card__title text-h1"
            }, _toDisplayString(_ctx.card.name), 513),
            _createElementVNode("div", {
              ref: "description",
              class: "card__descriptions",
              innerHTML: _ctx.card.description
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialLinks, ({ icon, network }, index) => {
                  return (_openBlock(), _createBlock(_component_social_icon, {
                    class: "divination__link-icon",
                    title: "Расклад таро на новый год",
                    icon: icon,
                    network: network,
                    href: _ctx.shareUrl.href,
                    key: index
                  }, null, 8, ["icon", "network", "href"]))
                }), 128))
              ])
            ], 512),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/en",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.setView('spread', 'home'))),
                class: "card__btn btn-main"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_touch_ripple, {
                    color: "#859dff",
                    opacity: 0.1,
                    transition: "ease-out",
                    duration: 300,
                    "keep-last-ripple": false
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["opacity"])
                ]),
                _: 1
              })
            ], 512)
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ], 6))
}